<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.25 3.75V8.25L11.25 9.75M15.75 8.25C15.75 12.3921 12.3921 15.75 8.25 15.75C4.10786 15.75 0.75 12.3921 0.75 8.25C0.75 4.10786 4.10786 0.75 8.25 0.75C12.3921 0.75 15.75 4.10786 15.75 8.25Z"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
